import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  Row,
  HeadingDisplay,
  ListDisplay,
  SkeletonLoader,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { InputMoney } from '@/modules/transaction/components/InputMoney';
import { RiskSignature } from '@/modules/common/components/RiskSignature';

import { IInvestmentInfo } from '@/modules/transaction/services/fund-pension-investment';
import {
  riskSignature,
  IRiskSignature
} from '@/modules/transaction/services/product-investment';

import { errorText, errorStatus, listDetails } from './helpers';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvestmentStep',
  setup(__props) {

const router = useRouter();

const investmentInfo = inject('investmentInfo') as Ref<IInvestmentInfo>;
const riskSignatureData = inject('riskSignatureData') as Ref<IRiskSignature>;
const productId = inject('productId') as Ref<string>;

const getInvestmentReview = inject(
  'fetchInvestmentReview',
  async (amount: number) => ({
    amount
  })
);

const isRiskSignatureOpen = ref(false);
const isLoading = ref(false);
const updateValue = ref(false);
const isButtonDisabled = ref(false);

const investmentInput = ref({
  value: 0,
  formatted: ''
});

const hasBalance = computed(() => {
  return investmentInfo.value.accountBalance.value > 0;
});

const balanceTitle = computed(() => {
  return hasBalance.value ? 'Saldo em conta' : 'Você não possui saldo';
});

const balanceValue = computed(() => {
  return hasBalance.value
    ? investmentInfo.value.accountBalance.formatted
    : 'Depositar';
});

const headerValueClass = computed(() => {
  return hasBalance.value ? '' : 'investment-step__header--value';
});

const status = computed(() => {
  return errorStatus(investmentInfo.value, investmentInput.value.value);
});

const helperText = computed(() => {
  return errorText(investmentInfo.value, investmentInput.value.value);
});

const details = computed(() => {
  return listDetails(investmentInfo.value);
});

const shortcuts = computed(() => {
  return investmentInfo.value.buttons;
});

const incrementValue = computed(() => {
  return investmentInfo.value.increment.value;
});

const minimumInvestment = computed(() => {
  return investmentInfo.value.minimumInvestment.value;
});

const isDisabled = computed(() => {
  return (
    investmentInput.value.value <= 0 ||
    status.value === 'error' ||
    isButtonDisabled.value
  );
});

function onChangeValue(data: {
  value: number;
  formatted: string;
  increment: boolean;
}) {
  investmentInput.value = data;
}

async function investClick() {
  if (riskSignatureData.value.requestRisksSignature.length > 0) {
    isRiskSignatureOpen.value = true;
    return;
  }

  await fetchInvestmentReview();
}

async function acceptRisk() {
  isRiskSignatureOpen.value = false;

  await fetchRiskSignature();
  await fetchInvestmentReview();
}

async function fetchInvestmentReview() {
  try {
    isLoading.value = true;

    await getInvestmentReview(investmentInput.value.value);
  } finally {
    isLoading.value = false;
  }
}

async function fetchRiskSignature() {
  try {
    isLoading.value = true;

    await riskSignature(productId.value);
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Houve um problema ao aceitar os riscos. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
}

function redirectToDeposit() {
  if (hasBalance.value) return;

  router.push({ name: 'deposit-pix' });
}

return { __sfc: true,router, investmentInfo, riskSignatureData, productId, getInvestmentReview, isRiskSignatureOpen, isLoading, updateValue, isButtonDisabled, investmentInput, hasBalance, balanceTitle, balanceValue, headerValueClass, status, helperText, details, shortcuts, incrementValue, minimumInvestment, isDisabled, onChangeValue, investClick, acceptRisk, fetchInvestmentReview, fetchRiskSignature, redirectToDeposit, NebraskaColors, BaseText, Row, HeadingDisplay, ListDisplay, SkeletonLoader, ButtonContainer, ButtonPrimary, InputMoney, RiskSignature }
}

})